export const TAGS = [
  {
    label: '舞台区',
    value: 1
  },
  {
    label: '仪式区',
    value: 2
  },
  {
    label: 'T台',
    value: 3
  },
  {
    label: '吊顶',
    value: 4
  }
]

export const KIND = {
  DesignDiagram: 1, // 设计稿
  DesignConcept: 2, // 设计构思
  StageCeremony: 3, // 舞台仪式
  WelcomeSign: 4, // 迎宾签到
  WeddingDetail: 5, // 婚礼细节
  NoSetting: 6 // 未设置分区
}

/**
 * @title 舞台仪式区 + 迎宾签到区 + 婚礼细节
 */
export const MAIN_AREA = [
  {
    label: '舞台仪式区',
    value: KIND['StageCeremony']
  },
  {
    label: '迎宾签到区',
    value: KIND['WelcomeSign']
  },
  {
    label: '婚礼细节',
    value: KIND['WeddingDetail']
  }
]
